<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
    <div class="container-fluid padding-bottom-small bottom-padding">
        <div class="col-sm-11 center-block">
            <h1 tabindex="0" aria-label="Upload File" role="heading" aria-level="1">Upload File</h1>
            <div class="row">
                <div class="col-md-12">
                  <app-file-upload
                    [iconClassName]="'fa-file-archive'"
                    [formatDisplayText]="'ZIP formats only'"
                    [allowExtensions]="'.zip'"
                    [saveUrl]="uploadSaveUrl"
                    (uploading)="onFileUploadStart($event)"
                    (success)="onFileUploadedSuccess($event)"
                    (failure)="onUploadFailure($event)"
                  >
                  </app-file-upload>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div id="validation-result">
                        <div class="validation-info">
                            <h3 tabindex="0" aria-label="Health Canada File Name" role="heading" aria-level="3">Health Canada File Name:</h3>
                            <span tabindex="0" aria-label="Validation file name">{{validationFileName}}</span>
                        </div>
                        <div class="validation-info">
                            <h3 tabindex="0" aria-label="File Status" role="heading" aria-level="3">File Status:</h3>
                            <span tabindex="0" aria-label="Validation upload status">{{uploadStatus}}</span>
                        </div>
                        <div class="validation-info">
                            <h3 tabindex="0" aria-label="Validation Status" role="heading" aria-level="3">Validation Status:</h3>
                            <span tabindex="0" aria-label="Validation status" [className]="validationStatusClassName">{{validationStatus}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" [hidden]='!splErrorMessages || splErrorMessages.length === 0'>
                <div class="col-md-12">
                    <div class="card bg-danger">
                        <div class="card-header accordion-links">
                            <a href='javascript:void(0)' (click)="showHideErrorsWarnings()"
                            role="link" aria-label="Show or hide errors and warinings" (keydown.enter)="showHideErrorsWarnings()">
                                <span class="alert-text">Validation errors and warnings </span>
                                <span class="alert-text" *ngIf="!isHideErrorsWarnings">
                                    <i class="fas fa-chevron-up"></i>
                                </span>
                                <span class="alert-text" *ngIf="isHideErrorsWarnings">
                                    <i class="fas fa-chevron-down"></i>
                                </span>
                            </a>
                        </div>
                        <div class="card-body card-error-messages" [hidden]="isHideErrorsWarnings">
                            <div class="row text-danger">
                                <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)"
                                             target=".e-tooltipcolumn" [enableHtmlParse]="false">
                                    <ejs-grid id='validationGrid' #validationGrid
                                        [dataSource]='splErrorMessages'
                                        [allowScrolling]="true"
                                        [allowPaging]='false'
                                        [allowSorting]='true'
                                        [allowTextWrap]='true'
                                        height="350"
                                        (queryCellInfo)='customiseCell($event)'>
                                        <e-columns>
                                            <e-column field='lineNumber' headerText='Line Number' width='60'></e-column>
                                            <e-column field='linePosition' headerText='Line Position' width='60'></e-column>
                                            <e-column [customAttributes]="{class: 'e-removewrap'}" field='fieldName' headerText='Field Name' width='110'></e-column>
                                            <e-column field='message' headerText='Message' width='310'></e-column>
                                            <e-column field='messageType' headerText='Message Type' width='60'></e-column>
                                        </e-columns>
                                    </ejs-grid>
                                </ejs-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--------------------------------
        PROGRESS SPINNER
        --------------------------------->
        <div *ngIf="pageState !== hcSplValidationService.PAGE_STATE_READY">
            <div id="loading"></div>
        </div>
    </div>
</main>
